// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__TQHHM","colCheckbox":"styles_colCheckbox__1tTzE"};